import React, { Fragment, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { isEqual } from 'lodash';
import { Editor } from "react-draft-wysiwyg";

import {
  Container,
  Header,
  Segment,
  Button,
  Icon,
  Loader
} from 'semantic-ui-react';

// import '../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import fire from '../../components/App/fire';
import ActionModal from '../../components/Modals/ActionModal'
// import Draggable from 'react-draggable'
// import { Droppable, Draggable, DragDropContext} from 'react-beautiful-dnd'

import { setReferenceData } from '../../routes/Reference/referenceSlice'
import { setActionModal } from '../../components/Modals/modalsSlice'

const style = {
  wordBreak: "break-word"
};

const Reference = () => {
  const activeAction = useSelector(state => state.app.activeAction)
  const referenceDataRedux = useSelector(state => state.reference)
  const actionModalProps = useSelector(state => state.modals.actionModalProps)
  const dispatch = useDispatch()
  const [referenceFireData, setReferenceFireData] = useState(null)
  const isAdd = activeAction === 'add'
  const referencePages = []

  let name
  let color
  let icon

  switch (activeAction) {
    case 'add':
      name = 'Add';
      color = 'blue';
      icon = 'add';
      break;
    case 'edit':
      name = 'Edit';
      color = 'blue';
      icon = 'pencil';
      break;
    case 'delete':
      name = 'Delete';
      color = 'red';
      icon = 'trash';
      break;
    default:
      break;
  }

  // Getting data from firebase
  fire
    .database()
    .ref('reference')
    .orderByKey()
    .on('value', snapshot => {
      if (!referenceFireData)
        setReferenceFireData(snapshot.val())
    });

  if (!referenceFireData) return <Loader />

  const { fields } = referenceFireData

  // if different, set new reference data from firebase to redux
  if (!isEqual(fields, referenceDataRedux)) {
    dispatch(setReferenceData(fields))
  }

  fields.forEach((val, index) => {
    referencePages.push((
      // <Draggable axis='y' disabled={!activeAction}>
      <Segment className='handle' id={index} key={index} raised={Boolean(activeAction)} basic={!activeAction}>
        <Header as='h1' color='blue'>
          {val.header}
          {activeAction && (
            <Button
              basic
              floated='right'
              color={color}
              onClick={() => dispatch(
                setActionModal({
                  header: isAdd ? '' : val.header,
                  content: isAdd ? '' : JSON.parse(val.content),
                  type: activeAction,
                  open: true,
                  key: index,
                  tab: 'reference'
                })
              )}
            >
              <Icon name={icon} /> {name}
            </Button>
          )}
        </Header>
        <Editor
          editorStyle={style}
          toolbarStyle={style}
          initialContentState={JSON.parse(val.content)}
          toolbarHidden
          readOnly
        />
      </Segment>
      // </Draggable>
    ))
  });

  return (
    <Fragment>
      <ActionModal modalType={actionModalProps.type} open={actionModalProps.open} />
      <Container>{referencePages}</Container>
    </Fragment>
  )
}

export default Reference